{
  "Accessibility Menu": "Meni Za Pristupačnost",
  "Reset settings": "Resetuj postavke",
  "Close": "Zatvori",
  "Content Adjustments": "Podešavanje Sadržaja",
  "Adjust Font Size": "Podešavanje Veličine Fonta",
  "Highlight Title": "Označi Naslove",
  "Highlight Links": "Označi Veze",
  "Readable Font": "Čitljiviji Font",
  "Color Adjustments": "Podešavanje Boja",
  "Dark Contrast": "Tamni Kontrast",
  "Light Contrast": "Svijetli Kontrast",
  "High Contrast": "Visoki Kontrast",
  "High Saturation": "Velika Zasićenost",
  "Low Saturation": "Niska Zasićenost",
  "Monochrome": "Jednobojni",
  "Contrast": "Kontrast",
  "Invert Colors": "Inverzija boja",
  "Tools": "Alati",
  "Reading Guide": "Vodič Za Čitanje",
  "Stop Animations": "Zaustavi Animacije",
  "Big Cursor": "Veliki Kursor",
  "Increase Font Size": "Povećaj Veličinu Fonta",
  "Decrease Font Size": "Smanji Veličinu Fonta",
  "Letter Spacing": "Razmak Slova",
  "Line Height": "Visina Linije",
  "Font Weight": "Debljina Fonta",
  "Dyslexia Font": "Font Za Disleksičare",
  "Language": "Jezik",
  "Open Accessibility Menu": "Otvori Meni Za Pristupačnost",
  "Widget Settings": "Podešavanja vidžeta",
  "Widget Position": "Pozicija vidžета",
  "Top Left": "Gore levo",
  "Top Center": "Gore u centru",
  "Top Right": "Gore desno",
  "Center Left": "Centar levo",
  "Center Right": "Centar desno",
  "Bottom Left": "Dole levo",
  "Bottom Center": "Dole u centru",
  "Bottom Right": "Dole desno",
  "Screen Reader": "Čitač ekrana",
  "Voice Navigation": "Glasovna navigacija",
  "Custom Color": "Prilagođena boja",
  "Change the site's colors": "Promeni boje sajta",
  "Backgrounds": "Pozadine",
  "Headings": "Naslovi",
  "Contents": "Sadržaj",
  "Reset colors": "Poništi boje",
  "Image Desaturation": "Desaturacija slike",
  "Search languages": "Pretraži jezike",
  "No languages found": "Nijedan jezik nije pronađen",
  "Accessibility Profiles": "Профили приступачности",
  "Motor Impaired": "Покретна ограничења",
  "Big cursor, voice navigation, and no animations.": "Велики курсор, гласовна навигација и без анимација.",
  "Blind": "Слепи",
  "Screen reader helpers with higher contrast.": "Помагачи читача екрана са већим контрастом.",
  "Color Blind": "Далтонзам",
  "High contrast palette with desaturated media.": "Палета високог контраста са умањеним бојама.",
  "Dyslexia": "Дислексија",
  "Friendly font, extra spacing, stronger weight.": "Лако читљив фонт, више размака и израженије слово.",
  "Low vision": "Слабовидост",
  "Dark contrast and 130% magnification.": "Таман контраст и 130% увећање.",
  "Cognitive & Learning": "Когнитивно и учење",
  "Highlights key sections and enables voice help.": "Истиче кључне целине и омогућава гласовну помоћ.",
  "Seizure & Epileptic": "Напади и епилепсија",
  "Stops animations and desaturates imagery.": "Зауставља анимације и умањује засићење слика.",
  "ADHD": "АДХД",
  "Reading guide, highlighted links, calmer palette.": "Водич за читање, наглашене везе и смиренија палета.",
  "Widget Size": "Widget Size",
  "Default": "Default",
  "Medium": "Medium",
  "Small": "Small",
  "Color Blindness": "Color Blindness",
  "Protanopia": "Protanopia",
  "Deuteranopia": "Deuteranopia",
  "Tritanopia": "Tritanopia",
  "Achromatopsia": "Achromatopsia",
  "Simulates and assists users with color vision deficiencies.": "Simulates and assists users with color vision deficiencies."
}
